<template>
  <div
    class="rounded-3xl container"
    style="backdrop-filter: blur(8px) brightness(100%)"
  >
    <TinySlider
      :options="{
        mode: 'gallery',
        controls: true,
        nav: true,
        speed: 500
      }"
    >
      <div
        class="mx-auto py-0 h-auto"
        v-for="slider in sliders"
        :key="slider.id"
      >
        <div
          v-if="slider.products?.length === 1"
          class="flex flex-col md:flex-row-reverse w-full h-[500px] md:h-[375px] lg:h-[500px] xl:h-[540px] mx-auto self-center p-4"
          style="border: 3px solid #ffffff47; border-radius: 20px"
        >
          <div class="w-full lg:p-4 pt-6">
            <img
              :src="slider.image[0]"
              alt="imagen del slider"
              class="h-52 lg:h-96 object-contain object-center w-full"
            />
          </div>
          <div class="w-full m-auto">
            <div class="inline-grid w-full">
              <h1
                class="text-theme-4 pb-1 text-3xl sm:text-5xl md:text-2xl lg:text-5xl text-center sm:text-left font-crimson_pro"
              >
                {{ slider.title }}
              </h1>
              <p
                class="text-base m:text-lg text-gray-900 pb-2 text-center sm:text-left mb-2 font-poppins"
              >
                {{ slider.description }}
              </p>
              <button
                class="m-auto sm:m-0 h-12 w-60 rounded text-white hover:scale-110 btn-deg font-poppins"
                @click="handlerOnClick(slider.products[0])"
              >
                Ver producto
              </button>
            </div>
          </div>
        </div>
        <div
          v-else-if="slider.products?.length > 1"
          class="w-full h-full max-w-[354px] max-h-[500px] md:max-w-[1110px] md:max-h-[540px] mx-auto cursor-pointer"
          @click="handlerOnClickSlider(slider)"
        >
          <img
            :src="slider.image[0]"
            alt="slider"
            class="w-full h-full object-contain object-center rounded-lg hidden md:flex"
          />
          <img
            :src="slider.image_mobile[0]"
            alt="slider"
            class="w-full h-full object-contain object-center rounded-lg flex md:hidden"
          />
        </div>
        <div
          v-else
          class="w-full h-full max-w-[354px] max-h-[500px] md:max-w-[1110px] md:max-h-[540px] mx-auto"
        >
          <img
            :src="slider.image[0]"
            alt="slider"
            class="w-full h-full object-contain object-center rounded-lg hidden md:flex"
          />
          <img
            :src="slider.image_mobile[0]"
            alt="slider"
            class="w-full h-full object-contain object-center rounded-lg flex md:hidden"
          />
        </div>
      </div>
    </TinySlider>
  </div>
</template>

<script>
import { formatter } from '@/utils/tools'
export default {
  data() {
    return {
      formatter: formatter
    }
  },
  props: {
    sliders: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    handlerOnClick(product) {
      if (product.productcolors.length > 0) {
        this.$router.push({ name: 'products', params: { id: product.id } })
      } else {
        this.$toast.error(
          'Lo sentimos, por el momento no contamos con stock para este producto',
          {
            position: 'top'
          }
        )
      }
    },
    handlerOnClickSlider(slider) {
      if (slider.products.length > 1) {
        this.$router.push({ name: 'catalogue', query: { sliderId: slider.id } })
      }
    }
  }
}
</script>
<style>
.btn-deg {
  background: linear-gradient(89.75deg, #e85c04 0.17%, #faa306 99.78%);
  transition: 0.3s;
  outline: 1px solid transparent;
  width: 200px;
  font-weight: 600;
}
</style>
